import QRCode from 'qrcode';

/**
 * Render `value` as a QR PNG and trigger a browser download. No-op for empty
 * values. Mirrors the splits screen's inline download logic.
 */
export const downloadQr = async (value: string, filename: string): Promise<void> => {
  if (!value) return;
  const url = await QRCode.toDataURL(value);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
};
